
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world-of-impact",
      function () {
        return require("private-next-pages/world-of-impact/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world-of-impact"])
      });
    }
  